import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SelectUI from '../../../widgets/input/SelectUI'
import SearchUI from '../../../widgets/input/SearchUI'
import CardUI from '../../../widgets/layout/CardUI'
import { Link } from 'react-router-dom'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import MonitoringActionModalSF from './MonitoringActionModalSF'
import MonitoringIntelligencePageNavUI from './MonitoringIntelligencePageNavUI'
import EMIDetailsDialogUI from './EMIDetailsDialogUI'
import AccountSummaryDialog from './AccountSummaryDialog'
import whatsappIcon from '../../../assets/finapp/whatsapp.png'
import React, { useState, useEffect } from 'react';
import './MonitoringIntelligence.css';
import PenalChargeDetailsDialogUI from './PenalChargeDetailsDialogUI'
import LegalChargeDetailsDialogUI from './LegalChargeDetailsDialogUI'
import PenalChargeDialogUI from './PenalChargeDialogUI '
import DsraDipDetailsDialogUI from './DsraDipDetailsDialogUI'
import DsraClauseDialogUI from './DsraClauseDialogUI'
import NoticeCreationModal from './NoticeCreationModal'

// Compliance codes that should NOT be shown as non-financial compliance rows
const HIDDEN_COMPLIANCE_CODES = new Set([
  'dsra_dip_in_case_of_levying_of_penal_charges',
  'dsra_dip_in_case_of_emi_default',
  'emi_default',
  'continuous_dsra_dip',
]);

const MonitoringIntelligenceUI = ({
  context, errorList, chequeBounceList, processedData, onRefreshClick,
  selectedStatus, onStatusChange, onSearchFilterChange, onLrnFilterChange, searchFilter, lrnFilter, onDownloadReport,
  getStatusDisplayValue, onDocDownloadClick,
  isUpdateMode, onUpdateMode, onUpdateModeClose, currentItem, yearMonth, onPreviousClick, onNextClick,
  selectedReportType, onReportTypeChange,
  onEmiDetailsClick, closeEmiDetailsModal, isEmiDetailsModalOpen, currentEmiDetails,
  onCreateWhatsappApproval, onCreateEmailApproval,
  onViewAccountSummary, isAccountSummaryOpen, currentAccountSummary, closeAccountSummaryModal,
  messageApprovalList, setOpenPenalClauseDialog, isPenalClauseModalOpen, closePenalClauseModal, currentPenalClauses,
  onLegalChargeDetailsClick, isLegalDetailsModalOpen, closeLegalDetailsModal, currentLegalDetails, onPenalChargeDetailsClick,
  setOpenDsraClauseDialog, isDsraClauseModalOpen, closeDsraClauseModal, currentDsraClause,
  isPenalDetailModalOpen, closePenalDetailModal, currentPenalDetails, onDsraShortfallDetailsClick, isDsraDetailModalOpen, closeDsraDetailModal, currentDsraDetails,
  isNoticeModalOpen, onOpenNoticeModal, onCloseNoticeModal, onCreateNoticeDraft, noticeModalType, noticeModalAccountId, noticeCreationLoading, nonFinancialComplianceData, downloadSubmitted, scheduleViiComplianceData

}) => {
  const isAnyDialogOpen = isEmiDetailsModalOpen || isAccountSummaryOpen || isUpdateMode || isPenalClauseModalOpen || isLegalDetailsModalOpen || isPenalDetailModalOpen || isDsraClauseModalOpen
    || isDsraDetailModalOpen || isNoticeModalOpen;

  return (
    <SuperUserHomePageUI
      context={context} className='pg_su_cr'
      topnav='monitoringIntelligence' page='monitoringIntelligence'
      centered={!chequeBounceList || !errorList}
      dimension='w1600'
    >
      {
        (!chequeBounceList || !errorList) &&
        <SpinnerComponentUI />
      }

      {errorList && errorList.length > 0 && <GenericErrorUI error={errorList[0]} />}

      {
        chequeBounceList &&
        <div>
          <div className="g_fixed_header_container" style={{
            position: isAnyDialogOpen ? 'static' : 'sticky',
            top: 0,
            zIndex: 1000,
            backgroundColor: 'white',
            borderBottom: '1px solid #e0e0e0',
            paddingBottom: '10px'
          }}>
            <LRTableActionsUI
              location='top'
              left={
                <div>
                  <span className='g_flex_left g_flex_h'>
                    <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh Page' />
                    <IconButtonUI
                      icon='icon-download'
                      onClick={onDownloadReport}
                      label={downloadSubmitted ? 'Downloading…' : 'Download MI Report'}
                      disabled={downloadSubmitted}
                    />
                    <span className='g_m_left_100 g_large'><b>Monitoring Intelligence, {yearMonth.monthName} {yearMonth.year}</b></span>
                  </span>
                </div>
              }
              right={
                <span className='g_text_left'>
                  <div className='g_flex_v'>
                    <div className='g_flex_h g_flex_right'>
                      <Link to='#' onClick={onPreviousClick}>Previous</Link>
                      <span className='g_m_left_100' />
                      <Link to='#' onClick={onNextClick}>Next</Link>
                    </div>
                    <div className='g_flex_h g_m_top_20'>
                      <div className='g_flex_v' >
                        <SearchUI value={searchFilter} onChange={onSearchFilterChange} placeholder="Search by account" />
                        <span className='g_muted g_small'>Search by account</span>
                      </div>
                      <div className='g_flex_v' >
                        <SearchUI value={lrnFilter} onChange={onLrnFilterChange} placeholder="Search by LRN" />
                        <span className='g_muted g_small'>Search by LRN</span>
                      </div>
                      <div className='g_flex_v g_m_left_50'>
                        <SelectUI
                          selectedKey={selectedReportType}
                          optionList={[
                            { label: 'All', value: 'all' },
                            { label: 'NACH Failure', value: 'nachFailure' },
                            { label: 'Legal Charge', value: 'legalCharge' },
                            { label: 'Penal Charge', value: 'penalCharge' },
                            { label: 'DSRA Shortfall', value: 'dsraShortfall' },
                            { label: 'EMI', value: 'emi' },
                            { label: 'Cheque Bounce', value: 'chequeBounce' },
                            { label: 'Non Financial', value: 'nonFinancial' },
                            { label: 'Schedule VII', value: 'scheduleVii' }
                          ]}
                          onChange={onReportTypeChange}
                          placeholder="Report Type"
                        />
                        <span className='g_muted g_small'>Filter by report type</span>
                      </div>
                      <div className='g_flex_v g_m_left_50' >
                        <SelectUI
                          selectedKey={selectedStatus}
                          optionList={[
                            { label: 'All', value: 'all' },
                            { label: 'Open', value: 'open' },
                            { label: 'Close', value: 'close' },
                            { label: 'Pending For Closure', value: 'pending_for_closure' }
                          ]}
                          onChange={onStatusChange}
                          placeholder="Status"
                        />
                        <span className='g_muted g_small'>Filter by status</span>
                      </div>
                    </div>
                  </div>
                </span>
              }
            />

            <MonitoringIntelligencePageNavUI
              context={context}
              page='monitoringIntelligence'
            />
          </div>

          <div style={{ marginTop: '10px' }}>
            <MonitoringIntelligenceTableUI
              processedData={processedData}
              context={context}
              getStatusDisplayValue={getStatusDisplayValue}
              onDocDownloadClick={onDocDownloadClick}
              onUpdateMode={onUpdateMode}
              onEmiDetailsClick={onEmiDetailsClick}
              onLegalChargeDetailsClick={onLegalChargeDetailsClick}
              onPenalChargeDetailsClick={onPenalChargeDetailsClick}
              onDsraShortfallDetailsClick={onDsraShortfallDetailsClick}
              onCreateWhatsappApproval={(accountId) => onOpenNoticeModal(accountId, 'whatsapp')}
              onCreateEmailApproval={(accountId) => onOpenNoticeModal(accountId, 'email')}
              onViewAccountSummary={onViewAccountSummary}
              isAnyDialogOpen={isAnyDialogOpen}
              messageApprovalList={messageApprovalList}
              lrnFilter={lrnFilter}
              setOpenPenalClauseDialog={setOpenPenalClauseDialog}
              setOpenDsraClauseDialog={setOpenDsraClauseDialog}
              nonFinancialComplianceData={nonFinancialComplianceData}
              scheduleViiComplianceData={scheduleViiComplianceData}
            />
          </div>

          {
            chequeBounceList.length === 0 &&
            <EmptyListUI
              context={context}
              createEnabled={false}
              createDisabledMessageLabel='No Monitoring Intelligence Found'
            />
          }

          <MonitoringActionModalSF
            context={context}
            isUpdateMode={isUpdateMode}
            onCancelClick={onUpdateModeClose}
            onRefreshClick={onRefreshClick}
            currentItem={currentItem}
          />

          <EMIDetailsDialogUI
            isOpen={isEmiDetailsModalOpen}
            onClose={closeEmiDetailsModal}
            details={currentEmiDetails}
          />
          <LegalChargeDetailsDialogUI
            isOpen={isLegalDetailsModalOpen}
            onClose={closeLegalDetailsModal}
            details={currentLegalDetails}
          />
          <PenalChargeDialogUI
            isOpen={isPenalDetailModalOpen}
            onClose={closePenalDetailModal}
            details={currentPenalDetails}
          />
          <DsraDipDetailsDialogUI
            isOpen={isDsraDetailModalOpen}
            onClose={closeDsraDetailModal}
            details={currentDsraDetails}
          />
          <PenalChargeDetailsDialogUI
            isOpen={isPenalClauseModalOpen}
            onClose={closePenalClauseModal}
            details={currentPenalClauses}
          />
          <DsraClauseDialogUI
            isOpen={isDsraClauseModalOpen}
            onClose={closeDsraClauseModal}
            defaultReason={currentDsraClause}
          />

          <AccountSummaryDialog
            isOpen={isAccountSummaryOpen}
            onClose={closeAccountSummaryModal}
            summaryData={currentAccountSummary}
          />
          <NoticeCreationModal
            isOpen={isNoticeModalOpen}
            onClose={onCloseNoticeModal}
            onCreateNotice={onCreateNoticeDraft}
            messageType={noticeModalType}
            accountId={noticeModalAccountId}
            loading={noticeCreationLoading}
            messageApprovalData={messageApprovalList[0]}
            context={context}
          />
        </div>
      }
    </SuperUserHomePageUI>
  )
}

const MonitoringIntelligenceTableUI = ({
  processedData, context, getStatusDisplayValue, onDocDownloadClick, onUpdateMode,
  onEmiDetailsClick, onCreateWhatsappApproval, onCreateEmailApproval, onViewAccountSummary, isAnyDialogOpen,
  messageApprovalList, lrnFilter, setOpenPenalClauseDialog, setOpenDsraClauseDialog, onLegalChargeDetailsClick, onPenalChargeDetailsClick,
  onDsraShortfallDetailsClick, nonFinancialComplianceData, scheduleViiComplianceData
}) => {
  const [sortType, setSortType] = useState('reset');
  const [expandedAccounts, setExpandedAccounts] = useState({});
  const [expandedNonFinancial, setExpandedNonFinancial] = useState({});
  const lrnDisplayTracker = {};

  const cleanNumber = (num) => {
    if (typeof num === "string") {
      return parseFloat(num.replace(/,/g, "")) || 0;
    }
    return Number(num) || 0;
  };

  const getMessageApprovalCounts = (accountId) => {
    if (!messageApprovalList || !accountId) return { whatsapp: 0, email: 0 };
    const normalizedAccountId = accountId ? accountId.toString().trim() : '';
    const filteredApprovals = messageApprovalList.filter(approval => {
      const approvalAccountId = approval.accountId ? approval.accountId.toString().trim() : '';
      return approvalAccountId === normalizedAccountId && approval.statusEnum === "success";
    });
    return {
      whatsapp: filteredApprovals.filter(a => a.messageApprovalType === "whatsapp").length,
      email: filteredApprovals.filter(a => a.messageApprovalType === "customerServiceEmail").length
    };
  };

  const hasSuccessfulNotices = (accountId) => {
    if (!messageApprovalList || !accountId) return false;
    const normalizedAccountId = accountId ? accountId.toString().trim() : '';
    return messageApprovalList.some(approval => {
      const approvalAccountId = approval.accountId ? approval.accountId.toString().trim() : '';
      return approvalAccountId === normalizedAccountId && approval.statusEnum === "success";
    });
  };

  const toggleNonFinancialCompliance = (accountName) => {
    setExpandedNonFinancial(prev => ({
      ...prev,
      [accountName]: !prev[accountName]
    }));
  };

  const handleViewAccountDetails = (accountName, summaryData) => {
    setExpandedAccounts(prev => ({
      ...prev,
      [accountName]: !prev[accountName]
    }));
    onViewAccountSummary(accountName, summaryData);
  };

  const accountGroups = {};
  const accountSummaries = {};

  useEffect(() => {
    if (processedData && processedData.length > 0) {
      const autoExpandedAccounts = {};
      processedData.forEach((row) => {
        autoExpandedAccounts[row.accountName] = true;
      });
      setExpandedAccounts(autoExpandedAccounts);
    }
  }, [processedData]);

  // Create a helper map for quick DSRA lookups
  const dsraShortfallMap = {};

  processedData.forEach((row) => {
    const { accountName, item } = row;
    if (item.reportType === "dsraShortfall") {
      dsraShortfallMap[accountName] = {
        dsra: cleanNumber(item.dsra ? item.dsra.toString() : "0"),
        dsraCur: cleanNumber(item.dsraCur ? item.dsraCur.toString() : "0"),
        dsraDip: cleanNumber(item.dsraDip ? item.dsraDip.toString() : "0")
      };
    }
  });

  // First, seed accountGroups from nonFinancialComplianceData so accounts
  // that have ONLY non-financial data (or whose financial rows were filtered out)
  // still get an account header row rendered.
  if (nonFinancialComplianceData) {
    Object.entries(nonFinancialComplianceData).forEach(([accountName, compliances]) => {
      if (!compliances || compliances.length === 0) return;
      const firstCompliance = compliances[0];
      if (!accountGroups[accountName]) {
        accountGroups[accountName] = []; // empty — no financial detail rows
      }
      if (!accountSummaries[accountName]) {
        accountSummaries[accountName] = {
          totalAmountDue: 0,
          totalAmountReceived: 0,
          totalAmountPending: 0,
          totalOverdueInterest: 0,
          loans: {},
          accountId: firstCompliance.accountId,
          dsraIncluded: false
        };
      }
    });
  }

  // Then layer in financial rows from processedData as before
  processedData.forEach((row) => {
    const { accountName, item } = row;

    if (item.reportType === "emi" && (!item.lrn || item.lrn === "N/A")) return;
    if (item.reportType === 'nonFinancialPlaceholder') return; // no longer needed

    const pendingAmount = cleanNumber(item.amountPending);
    if (pendingAmount === 0) return;

    if (!accountGroups[accountName]) accountGroups[accountName] = [];
    accountGroups[accountName].push(row);

    if (!accountSummaries[accountName]) {
      accountSummaries[accountName] = {
        totalAmountDue: 0,
        totalAmountReceived: 0,
        totalAmountPending: 0,
        totalOverdueInterest: 0,
        loans: {},
        accountId: item.accountId,
        dsraIncluded: false
      };
    }

    const isValidReportType = ["emi", "legalCharge", "penalCharge"].includes(item.reportType);

    if (isValidReportType) {
      accountSummaries[accountName].totalAmountDue += cleanNumber(item.amount);
      accountSummaries[accountName].totalAmountReceived += cleanNumber(item.amountReceived);
      accountSummaries[accountName].totalAmountPending += cleanNumber(item.amountPending);
      if (item.reportType === "emi") {
        accountSummaries[accountName].totalOverdueInterest += cleanNumber(item.overdueInterest);
      }
    }

    if (item.lrn && item.lrn !== "N/A") {
      if (!accountSummaries[accountName].loans[item.lrn]) {
        accountSummaries[accountName].loans[item.lrn] = {
          loanId: item.loanId,
          totalDue: 0,
          totalReceived: 0,
          totalPending: 0,
          totalOverdueInterest: 0
        };
      }
      if (isValidReportType) {
        accountSummaries[accountName].loans[item.lrn].totalDue += cleanNumber(item.amount);
        accountSummaries[accountName].loans[item.lrn].totalReceived += cleanNumber(item.amountReceived);
        accountSummaries[accountName].loans[item.lrn].totalPending += cleanNumber(item.amountPending);
        if (item.reportType === "emi") {
          accountSummaries[accountName].loans[item.lrn].totalOverdueInterest += cleanNumber(item.overdueInterest);
        }
      }
    }
  });

  Object.entries(dsraShortfallMap).forEach(([accountName, dsraData]) => {
    if (accountSummaries[accountName] && !accountSummaries[accountName].dsraIncluded) {
      accountSummaries[accountName].totalAmountDue += dsraData.dsra;
      accountSummaries[accountName].totalAmountReceived += dsraData.dsraCur;
      accountSummaries[accountName].totalAmountPending += dsraData.dsraDip;
      accountSummaries[accountName].dsraIncluded = true;
    }
  });

  const filteredAccountSummaries = {};

  if (lrnFilter && lrnFilter.trim() !== '') {
    const normalizedLrnFilter = lrnFilter.trim().toLowerCase();

    Object.entries(accountGroups).forEach(([accountName, rows]) => {
      filteredAccountSummaries[accountName] = {
        totalAmountDue: 0,
        totalAmountReceived: 0,
        totalAmountPending: 0,
        totalOverdueInterest: 0,
        loans: {},
        accountId: accountSummaries[accountName].accountId
      };

      const filteredRows = rows.filter(row =>
        row.item.lrn &&
        row.item.lrn.toLowerCase().includes(normalizedLrnFilter)
      );

      filteredRows.forEach(row => {
        const { item } = row;
        const isValidReportType = ["emi", "legalCharge", "penalCharge", "dsraShortfall"].includes(item.reportType);
        if (isValidReportType) {
          filteredAccountSummaries[accountName].totalAmountDue += cleanNumber(item.amount);
          filteredAccountSummaries[accountName].totalAmountReceived += cleanNumber(item.amountReceived);
          filteredAccountSummaries[accountName].totalAmountPending += cleanNumber(item.amountPending);
          if (item.reportType === "emi") {
            filteredAccountSummaries[accountName].totalOverdueInterest += cleanNumber(item.overdueInterest);
          }
        }
      });
    });
  }

  let filteredAccountEntries = Object.entries(accountGroups);

  if (lrnFilter && lrnFilter.trim() !== '') {
    const normalizedLrnFilter = lrnFilter.trim().toLowerCase();
    filteredAccountEntries = filteredAccountEntries.filter(([accountName, rows]) => {
      return rows.some(row =>
        row.item.lrn &&
        row.item.lrn.toLowerCase().includes(normalizedLrnFilter)
      );
    });
  }

  const sortedAccountEntries = [...filteredAccountEntries];

  const summaryToUse = (lrnFilter && lrnFilter.trim() !== '')
    ? filteredAccountSummaries
    : accountSummaries;

  if (sortType === 'max') {
    sortedAccountEntries.sort((a, b) =>
      summaryToUse[b[0]].totalAmountPending - summaryToUse[a[0]].totalAmountPending
    );
  } else if (sortType === 'min') {
    sortedAccountEntries.sort((a, b) =>
      summaryToUse[a[0]].totalAmountPending - summaryToUse[b[0]].totalAmountPending
    );
  } else {
    sortedAccountEntries.sort((a, b) => a[0].localeCompare(b[0]));
  }

  return (
    <CardUI className='scard'>
      <div className="mi-sort-bar">
        <span className="mi-sort-label">Sort by Account Total:</span>
        <button
          className={`g_btn g_btn_outline mi-sort-btn${sortType === 'max' ? ' mi-sort-btn-active-max' : ''}`}
          onClick={() => setSortType('max')}
        >
          <span>▲ Max</span>
        </button>
        <button
          className={`g_btn g_btn_outline mi-sort-btn${sortType === 'min' ? ' mi-sort-btn-active-min' : ''}`}
          onClick={() => setSortType('min')}
        >
          <span>▼ Min</span>
        </button>
        <button
          className={`g_btn g_btn_outline mi-sort-btn${sortType === 'reset' ? ' mi-sort-btn-active-reset' : ''}`}
          onClick={() => setSortType('reset')}
        >
          <span>Reset</span>
        </button>
      </div>
      <div
        className="mi-legend-bar"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '20px',
          padding: '8px 14px',
          fontSize: '0.78rem',
          color: '#374151',
          borderBottom: '1px solid #eee',
          flexWrap: 'wrap',
        }}
      >
        {/* <span style={{ fontWeight: 600 }}>Legend:</span> */}
        <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <span style={{ width: 12, height: 12, borderRadius: 3, background: '#fff7ed', border: '1px solid #f97316', display: 'inline-block' }} />
          Non-financial compliance open for this loan
        </span>
        <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <span style={{ width: 12, height: 12, borderRadius: 3, background: '#f0f9ff', border: '1px solid #3b82f6', display: 'inline-block' }} />
          Due date extended
        </span>
        <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <span style={{ width: 12, height: 12, borderRadius: 3, background: '#fdf4ff', border: '1px solid #a855f7', display: 'inline-block' }} />
          Penal charge auto-levied for non-compliance
        </span>
        <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <span style={{ width: 12, height: 12, borderRadius: 3, background: '#ecfeff', border: '1px solid #06b6d4', display: 'inline-block' }} />
          Schedule VII compliance
        </span>
      </div>

      <div className={`mi-table-wrapper ${isAnyDialogOpen ? 'dialog-open' : ''}`} style={{
        position: 'relative',
        maxHeight: '70vh',
        overflow: 'auto'
      }}>
        <table className='table_cr table'>
          <thead style={{
            position: isAnyDialogOpen ? 'static' : 'sticky',
            top: 0,
            zIndex: 100,
            backgroundColor: 'white',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}>
            <tr>
              <th>S.No</th>
              <th>Account</th>
              <th>LRN</th>
              <th>Type</th>
              <th>Amount Required/DSRA Required</th>
              <th>Amount Received/DSRA Current</th>
              <th>Amount Pending/DSRA Dip </th>
              <th>OverDue Interest</th>
              <th>Last Payment Date</th>
              <th>Date Of Default</th>
              <th>Cure Date</th>
              <th>Default Reason</th>
              <th>Status</th>
              <th>Monitoring Actions</th>
              <th>Monitoring Comment</th>
              <th>Files</th>
              <th>Message</th>
            </tr>
          </thead>
          <tbody>
            {sortedAccountEntries.length > 0 ? (
              sortedAccountEntries.map(([accountName, rows], accountIndex) => {
                const summary = (lrnFilter && lrnFilter.trim() !== '')
                  ? filteredAccountSummaries[accountName]
                  : accountSummaries[accountName];
                const accountId = summary.accountId;
                const isExpanded = expandedAccounts[accountName];
                const approvalCounts = getMessageApprovalCounts(accountId);
                const hasNotices = hasSuccessfulNotices(accountId);
                const isNonFinancialExpanded = expandedNonFinancial[accountName];
                const accountNonFinancialData = (nonFinancialComplianceData && nonFinancialComplianceData[accountName]) || [];
                const accountScheduleViiData = (scheduleViiComplianceData && scheduleViiComplianceData[accountName]) || [];

                const accountSummaryRow = [
                  <tr key={`summary-${accountName}`} className="g_account_summary_row">
                    <td className="g_text_left">{accountIndex + 1}</td>
                    <td className="g_text_left">
                      <div className="g_flex_v g_flex_left">
                        <div
                          className={`g_bold ${hasNotices ? 'g_text_danger' :
                            rows.some(row => row.item.reportType === "dsraShortfall") ? 'g_info' :
                              (rows.length > 0 && rows.every(row => row.item.reportType === "dsraShortfall" || row.item.closureStatus === "close")) ? 'g_success' : ''}`}
                        >
                          {(() => {
                            const firstLoan = Object.values(summary.loans || {})[0];
                            const loanId = firstLoan ? firstLoan.loanId : null;
                            return loanId ? (
                              <Link
                                to={`/su/loans/${loanId}/bankAccounts`}
                                className="g_link"
                                style={{ color: '#65BDF0' }}
                              >
                                {accountName}
                              </Link>
                            ) : (
                              <span>{accountName}</span>
                            );
                          })()}
                        </div>
                      </div>
                    </td>
                    <td colSpan={2} className="g_text_center g_bold" style={{ color: '#80154a' }}>
                    </td>
                    <td className="g_text_left g_bold" style={{ color: '#80154a' }}>
                      {summary.totalAmountDue.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                    </td>
                    <td className="g_text_left g_bold" style={{ color: '#80154a' }}>
                      {summary.totalAmountReceived.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                    </td>
                    <td className="g_text_left g_bold" style={{ color: '#80154a' }}>
                      {summary.totalAmountPending.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                    </td>
                    <td className="g_text_left g_bold" style={{ color: '#80154a' }}>-</td>
                    <td colSpan={8}></td>
                    <td className="g_text_left">
                      <div className="g_flex_h g_flex_middle">
                        <div className="g_flex_v g_m_right_15">
                          <button
                            onClick={() => onCreateWhatsappApproval(accountId)}
                            className="g_icon_button g_m_right_5 whatsapp-button"
                            title="Create WhatsApp message approval"
                          >
                            <img src={whatsappIcon} alt="WhatsApp" width="20" height="20" />
                          </button>
                          {approvalCounts.whatsapp > 0 && (
                            <div className="g_text_small g_text_center message-count-indicator g_text_danger">
                              <strong>Sent: {approvalCounts.whatsapp}</strong>
                            </div>
                          )}
                        </div>
                        <div className="g_flex_v">
                          <IconButtonUI
                            icon='icon-envelope'
                            onClick={() => onCreateEmailApproval(accountId)}
                            label="Create Email message approval"
                          />
                          {approvalCounts.email > 0 && (
                            <div className="g_text_small g_text_center message-count-indicator g_text_danger">
                              <strong>Sent: {approvalCounts.email}</strong>
                            </div>
                          )}
                        </div>
                      </div>
                    </td>
                  </tr>
                ];

                const loanDetailRows = [];

                // ── Non-financial compliance filtering ──
                // Filter out hidden compliance codes from display.
                // But for each LRN group: if the loan's compliances are exclusively
                // hidden codes AND a nonFinancialPenalCharge exists, we still show
                // the penal charge row for that LRN.
                const nfcVisible = accountNonFinancialData.filter(
                  c =>
                    (c.fileStatus === 'not_complied' || c.fileStatus === 'due_date_extended') &&
                    !HIDDEN_COMPLIANCE_CODES.has(c.legalLanguageCode)
                );

                // Collect LRNs where ALL compliances (not_complied / due_date_extended)
                // were hidden — so we still need to surface their penal-charge rows.
                // Group ALL filtered compliances (not_complied / due_date_extended) by LRN
                const allRelevantByLrn = {};
                accountNonFinancialData
                  .filter(c => c.fileStatus === 'not_complied' || c.fileStatus === 'due_date_extended')
                  .forEach(c => {
                    if (!allRelevantByLrn[c.lrn]) allRelevantByLrn[c.lrn] = [];
                    allRelevantByLrn[c.lrn].push(c);
                  });

                // LRNs where every compliance is hidden (none are visible)
                const lrnsWithOnlyHiddenCompliances = new Set(
                  Object.entries(allRelevantByLrn)
                    .filter(([lrn, comps]) =>
                      comps.every(c => HIDDEN_COMPLIANCE_CODES.has(c.legalLanguageCode))
                    )
                    .map(([lrn]) => lrn)
                );

                // Determine which LRNs need a penal-charge-only row (no visible compliances,
                // but a nonFinancialPenalCharge exists for that loan).
                // We need to find the nonFinancialPenalCharge per LRN from processedData.
                const penalChargeOnlyRows = [];
                lrnsWithOnlyHiddenCompliances.forEach(lrn => {
                  // Find the representative compliance entry for this LRN to get loanId / yearMonth
                  const representative = allRelevantByLrn[lrn][0];
                  if (!representative) return;

                  // Find the nonFinancialPenalCharge for this loanId from processedData
                  const loanRow = processedData.find(
                    r => r.item && r.item.loanId === representative.loanId && r.item.nonFinancialPenalCharge
                  );
                  // Also check via accountNonFinancialData representative's penalCharge field
                  // (some data shapes may carry it directly)
                  const penalCharge =
                    (loanRow && loanRow.item.nonFinancialPenalCharge) ||
                    representative.nonFinancialPenalCharge ||
                    null;

                  if (penalCharge) {
                    penalChargeOnlyRows.push({ lrn, loanId: representative.loanId, yearMonth: representative.yearMonth, penalCharge });
                  }
                });

                // ── Build non-financial rows ──
                const lrnPenalSeen = new Set();
                const nfcLrnSeen = new Set();
                const nonFinancialRows = [];

                // First: render penal-charge-only rows for LRNs that only had hidden compliances
                penalChargeOnlyRows.forEach(({ lrn, loanId, yearMonth: ym, penalCharge }) => {
                  lrnPenalSeen.add(lrn);
                  nfcLrnSeen.add(lrn);

                  nonFinancialRows.push(
                    <tr
                      key={`nfc-penal-only-${accountName}-${lrn}`}
                      style={{
                        backgroundColor: '#fdf4ff',
                        borderLeft: '3px solid #a855f7'
                      }}
                    >
                      <td></td>
                      <td></td>
                      <td className="g_text_left">
                        <span style={{ fontSize: '0.82rem', fontWeight: 500, color: '#374151' }}>
                          {lrn || 'N/A'}
                        </span>
                      </td>
                      <td className="g_text_left">
                        <Link
                          to={`/su/loans/${loanId}/compliance/cs`}
                          className="g_link"
                          style={{ textDecoration: 'none' }}
                        >
                          <span
                            style={{
                              display: 'inline-block',
                              padding: '2px 7px',
                              borderRadius: '4px',
                              backgroundColor: '#f3e8ff',
                              color: '#7e22ce',
                              fontWeight: 600,
                              fontSize: '0.78rem',
                              letterSpacing: '0.02em'
                            }}
                          >
                            {(() => {
                              if (!ym) return 'Non-Financial Penal';
                              const [year, month] = ym.split('-');
                              const date = new Date(year, month - 1);
                              return `Penal charges for ${date.toLocaleString('en-IN', {
                                month: 'long',
                                year: 'numeric'
                              })}`;
                            })()}
                          </span>
                        </Link>
                      </td>
                      <td className="g_text_left">
                        <span style={{ fontSize: '0.82rem', color: '#7e22ce', fontWeight: 600 }}>
                          {penalCharge}
                        </span>
                      </td>
                      <td className="g_text_left g_muted" style={{ fontSize: '0.82rem' }}>-</td>
                      <td className="g_text_left">
                        <span style={{ fontSize: '0.82rem', color: '#7e22ce', fontWeight: 600 }}>-</span>
                      </td>
                      <td className="g_text_left g_muted" style={{ fontSize: '0.82rem' }}>-</td>
                      <td className="g_text_left g_muted" style={{ fontSize: '0.82rem' }}>-</td>
                      <td className="g_text_left g_muted" style={{ fontSize: '0.82rem' }}>-</td>
                      <td className="g_text_left g_muted" style={{ fontSize: '0.82rem' }}>-</td>
                      <td className="g_text_left">
                        <span style={{ fontSize: '0.82rem', color: '#6b21a8', fontStyle: 'italic' }}>
                          Penal charge for non-financial non-compliances
                        </span>
                      </td>
                      <td className="g_text_left g_muted" style={{ fontSize: '0.82rem' }}>-</td>
                      <td className="g_text_left g_muted" style={{ fontSize: '0.82rem' }}>-</td>
                      <td className="g_text_left g_muted" style={{ fontSize: '0.82rem' }}>-</td>
                      <td className="g_text_left g_muted" style={{ fontSize: '0.82rem' }}>-</td>
                      <td></td>
                    </tr>
                  );
                });

                // Second: render visible non-financial compliance rows (and their penal rows)
                nfcVisible.forEach((compliance, idx) => {
                  const isFirstOfLrn = idx === 0 || nfcVisible[idx - 1].lrn !== compliance.lrn;
                  const isDueDateExtended = compliance.fileStatus === 'due_date_extended';
                  const isOverdue = compliance.daysPastDue && parseInt(compliance.daysPastDue) > 0;

                  const statusConfig = isDueDateExtended
                    ? { label: 'Due Date Extended', bg: '#eff6ff', color: '#1d4ed8' }
                    : { label: 'Not Complied', bg: '#fef2f2', color: '#dc2626' };

                  // Inject the penal charge row once per LRN (before first visible compliance of that LRN)
                  if (isFirstOfLrn && compliance.nonFinancialPenalCharge && !lrnPenalSeen.has(compliance.lrn)) {
                    lrnPenalSeen.add(compliance.lrn);
                    nfcLrnSeen.add(compliance.lrn);

                    nonFinancialRows.push(
                      <tr
                        key={`nfc-penal-${accountName}-${compliance.lrn}`}
                        style={{
                          backgroundColor: '#fdf4ff',
                          borderLeft: '3px solid #a855f7'
                        }}
                      >
                        <td></td>
                        <td></td>
                        <td className="g_text_left">
                          <span style={{ fontSize: '0.82rem', fontWeight: 500, color: '#374151' }}>
                            {compliance.lrn || 'N/A'}
                          </span>
                        </td>
                        <td className="g_text_left">
                          <Link
                            to={`/su/loans/${compliance.loanId}/compliance/cs`}
                            className="g_link"
                            style={{ textDecoration: 'none' }}
                          >
                            <span
                              style={{
                                display: 'inline-block',
                                padding: '2px 7px',
                                borderRadius: '4px',
                                backgroundColor: '#f3e8ff',
                                color: '#7e22ce',
                                fontWeight: 600,
                                fontSize: '0.78rem',
                                letterSpacing: '0.02em'
                              }}
                            >
                              {(() => {
                                if (!compliance.yearMonth) return 'Non-Financial Penal';
                                const [year, month] = compliance.yearMonth.split('-');
                                const date = new Date(year, month - 1);
                                return `Penal charges for ${date.toLocaleString('en-IN', {
                                  month: 'long',
                                  year: 'numeric'
                                })}`;
                              })()}
                            </span>
                          </Link>
                        </td>
                        <td className="g_text_left">
                          <span style={{ fontSize: '0.82rem', color: '#7e22ce', fontWeight: 600 }}>
                            {compliance.nonFinancialPenalCharge}
                          </span>
                        </td>
                        <td className="g_text_left g_muted" style={{ fontSize: '0.82rem' }}>-</td>
                        <td className="g_text_left">
                          <span style={{ fontSize: '0.82rem', color: '#7e22ce', fontWeight: 600 }}>-</span>
                        </td>
                        <td className="g_text_left g_muted" style={{ fontSize: '0.82rem' }}>-</td>
                        <td className="g_text_left g_muted" style={{ fontSize: '0.82rem' }}>-</td>
                        <td className="g_text_left g_muted" style={{ fontSize: '0.82rem' }}>-</td>
                        <td className="g_text_left g_muted" style={{ fontSize: '0.82rem' }}>-</td>
                        <td className="g_text_left">
                          <span style={{ fontSize: '0.82rem', color: '#6b21a8', fontStyle: 'italic' }}>
                            Penal charge for non-financial non-compliances
                          </span>
                        </td>
                        <td className="g_text_left g_muted" style={{ fontSize: '0.82rem' }}>-</td>
                        <td className="g_text_left g_muted" style={{ fontSize: '0.82rem' }}>-</td>
                        <td className="g_text_left g_muted" style={{ fontSize: '0.82rem' }}>-</td>
                        <td className="g_text_left g_muted" style={{ fontSize: '0.82rem' }}>-</td>
                        <td></td>
                      </tr>
                    );
                  }

                  // Show LRN in compliance row only if not yet shown by penal row or prior compliance row
                  const showLrnInThisRow = !nfcLrnSeen.has(compliance.lrn);
                  if (showLrnInThisRow) {
                    nfcLrnSeen.add(compliance.lrn);
                  }

                  nonFinancialRows.push(
                    <tr
                      key={`nfc-${accountName}-${idx}`}
                      style={{
                        backgroundColor: isDueDateExtended ? '#f0f9ff' : '#fff7ed',
                        borderLeft: `3px solid ${isDueDateExtended ? '#3b82f6' : '#f97316'}`
                      }}
                    >
                      <td></td>
                      <td></td>
                      <td className="g_text_left">
                        {showLrnInThisRow ? (
                          <span style={{ fontSize: '0.82rem', fontWeight: 500, color: '#374151' }}>
                            {compliance.lrn || 'N/A'}
                          </span>
                        ) : ''}
                      </td>

                      <td className="g_text_left">
                        <Link
                          to={`/su/loans/${compliance.loanId}/compliance/cs`}
                          className="g_link"
                          style={{ textDecoration: 'none' }}
                        >
                          <span
                            style={{
                              display: 'inline-block',
                              padding: '2px 7px',
                              borderRadius: '4px',
                              backgroundColor: '#ffedd5',
                              color: '#c2410c',
                              fontWeight: 600,
                              fontSize: '0.78rem',
                              letterSpacing: '0.02em'
                            }}
                          >
                            {(() => {
                              if (compliance.reportType && compliance.reportType !== 'nonFinancial') {
                                return compliance.reportType;
                              }
                              const clause = compliance.clause || '';
                              const parts = clause.split(' - ');
                              if (parts.length > 1) {
                                return parts.slice(1).join(' - ').trim();
                              }
                              return compliance.complianceTitle || 'Non Finance';
                            })()}
                          </span>
                        </Link>
                      </td>

                      <td className="g_text_left g_muted" style={{ fontSize: '0.82rem' }}>-</td>
                      <td className="g_text_left g_muted" style={{ fontSize: '0.82rem' }}>-</td>
                      <td className="g_text_left g_muted" style={{ fontSize: '0.82rem' }}>-</td>
                      <td className="g_text_left g_muted" style={{ fontSize: '0.82rem' }}>-</td>
                      <td className="g_text_left g_muted" style={{ fontSize: '0.82rem' }}>-</td>

                      <td className="g_text_left">
                        {compliance.dueDate ? (
                          <div className="g_flex_v">
                            <span style={{ fontSize: '0.82rem', color: '#374151' }}>{compliance.dueDate}</span>
                            {isOverdue && (
                              <span style={{ fontSize: '0.72rem', color: '#dc2626', fontWeight: 500, marginTop: '2px' }}>
                                {compliance.daysPastDue}d overdue
                              </span>
                            )}
                          </div>
                        ) : (
                          <span className="g_muted" style={{ fontSize: '0.82rem' }}>-</span>
                        )}
                      </td>

                      <td className="g_text_left g_muted" style={{ fontSize: '0.82rem' }}>-</td>

                      <td className="g_text_left">
                        <span style={{ fontSize: '0.82rem', color: '#1f2937', lineHeight: '1.4' }}>
                          {compliance.clause || 'N/A'}
                        </span>
                      </td>

                      <td className="g_text_left">
                        <span style={{
                          display: 'inline-block',
                          padding: '2px 8px',
                          borderRadius: '4px',
                          backgroundColor: statusConfig.bg,
                          color: statusConfig.color,
                          fontSize: '0.75rem',
                          fontWeight: 600,
                          whiteSpace: 'nowrap'
                        }}>
                          {statusConfig.label}
                        </span>
                      </td>

                      <td className="g_text_left">
                        {isFirstOfLrn ? (
                          <span style={{ fontSize: '0.82rem', color: '#374151' }}>
                            {(compliance.monitoringAction && compliance.monitoringAction.trim()) || (
                              <span className="g_muted">Not set</span>
                            )}
                          </span>
                        ) : (
                          <span className="g_muted" style={{ fontSize: '0.82rem' }}>-</span>
                        )}
                      </td>

                      <td className="g_text_left">
                        <div className="g_flex_h g_flex_middle">
                          {isFirstOfLrn ? (
                            <span style={{ fontSize: '0.82rem', color: '#374151' }}>
                              {(compliance.monitoringComment && compliance.monitoringComment.trim()) || (
                                <span className="g_muted">Not set</span>
                              )}
                            </span>
                          ) : (
                            <span className="g_muted" style={{ fontSize: '0.82rem' }}>-</span>
                          )}
                          {isFirstOfLrn && (
                            <span
                              className="icon icon-pencil g_cursor_pointer g_muted g_m_left_10"
                              onClick={() => onUpdateMode({ ...compliance, reportType: 'nonFinancial' })}
                              style={{ verticalAlign: 'top', fontSize: '0.8rem' }}
                              title="Edit monitoring comment for this loan (LRN)"
                            />
                          )}
                        </div>
                      </td>

                      <td className="g_text_left g_muted" style={{ fontSize: '0.82rem' }}>-</td>
                      <td></td>
                    </tr>
                  );
                });
                // ── Build Schedule VII rows ──
                const scheduleViiRows = [];
                const sviiLrnSeen = new Set();

                accountScheduleViiData.forEach((compliance, idx) => {
                  const isFirstOfLrn = idx === 0 || accountScheduleViiData[idx - 1].lrn !== compliance.lrn;
                  const showLrnInThisRow = !sviiLrnSeen.has(compliance.lrn);
                  if (showLrnInThisRow) sviiLrnSeen.add(compliance.lrn);

                  scheduleViiRows.push(
                    <tr
                      key={`svii-${accountName}-${idx}`}
                      style={{
                        backgroundColor: '#ecfeff',
                        borderLeft: '3px solid #06b6d4'
                      }}
                    >
                      <td></td>
                      <td></td>
                      <td className="g_text_left">
                        {showLrnInThisRow ? (
                          <span style={{ fontSize: '0.82rem', fontWeight: 500, color: '#374151' }}>
                            {compliance.lrn || 'N/A'}
                          </span>
                        ) : ''}
                      </td>

                      <td className="g_text_left">
                        <Link
                          to={`/su/loans/${compliance.loanId}/compliance/cs`}
                          className="g_link"
                          style={{ textDecoration: 'none' }}
                        >
                          <span
                            style={{
                              display: 'inline-block',
                              padding: '2px 7px',
                              borderRadius: '4px',
                              backgroundColor: '#cffafe',
                              color: '#0e7490',
                              fontWeight: 600,
                              fontSize: '0.78rem',
                              letterSpacing: '0.02em'
                            }}
                          >
                            Schedule VII
                          </span>
                        </Link>
                      </td>

                      <td className="g_text_left">
                        <span style={{ fontSize: '0.82rem', color: '#0e7490', fontWeight: 600 }}>
                          {compliance.expectedInflow || '-'}
                        </span>
                      </td>
                      <td className="g_text_left">
                        <span style={{ fontSize: '0.82rem', color: '#0e7490', fontWeight: 600 }}>
                          {compliance.actualInflow || '-'}
                        </span>
                      </td>
                      <td className="g_text_left">
                        <span style={{ fontSize: '0.82rem', color: '#0e7490', fontWeight: 600 }}>
                          {compliance.shortfall || '-'}
                        </span>
                        {compliance.shortfallPercent && (
                          <div style={{ fontSize: '0.72rem', color: '#dc2626', fontWeight: 500, marginTop: '2px' }}>
                            {compliance.shortfallPercent} short
                          </div>
                        )}
                      </td>
                      <td className="g_text_left g_muted" style={{ fontSize: '0.82rem' }}>-</td>
                      <td className="g_text_left g_muted" style={{ fontSize: '0.82rem' }}>-</td>
                      <td className="g_text_left g_muted" style={{ fontSize: '0.82rem' }}>-</td>
                      <td className="g_text_left g_muted" style={{ fontSize: '0.82rem' }}>-</td>

                      <td className="g_text_left">
                        <span style={{ fontSize: '0.82rem', color: '#1f2937', lineHeight: '1.4' }}>
                          {compliance.nonComplianceText || compliance.clause || compliance.complianceTitle || 'N/A'}
                        </span>
                      </td>

                      <td className="g_text_left">
                        <span style={{
                          display: 'inline-block',
                          padding: '2px 8px',
                          borderRadius: '4px',
                          backgroundColor: '#f0fdfa',
                          color: '#0f766e',
                          fontSize: '0.75rem',
                          fontWeight: 600,
                          whiteSpace: 'nowrap'
                        }}>
                          {compliance.status === 'not_complied' ? 'Not Complied' : (compliance.status || '-')}
                        </span>
                        {compliance.clarificationEmailSent === 'yes' && (
                          <div style={{ marginTop: '4px' }}>
                            <span style={{
                              display: 'inline-block',
                              padding: '1px 6px',
                              borderRadius: '4px',
                              backgroundColor: '#ecfdf5',
                              color: '#047857',
                              fontSize: '0.68rem',
                              fontWeight: 600
                            }}>
                              Clarification email sent
                            </span>
                          </div>
                        )}
                      </td>

                      <td className="g_text_left">
                        {isFirstOfLrn ? (
                          <span style={{ fontSize: '0.82rem', color: '#374151' }}>
                            {(compliance.monitoringAction && compliance.monitoringAction.trim()) || (
                              <span className="g_muted">Not set</span>
                            )}
                          </span>
                        ) : (
                          <span className="g_muted" style={{ fontSize: '0.82rem' }}>-</span>
                        )}
                      </td>

                      <td className="g_text_left">
                        <div className="g_flex_h g_flex_middle">
                          {isFirstOfLrn ? (
                            <span style={{ fontSize: '0.82rem', color: '#374151' }}>
                              {(compliance.monitoringComment && compliance.monitoringComment.trim()) || (
                                <span className="g_muted">Not set</span>
                              )}
                            </span>
                          ) : (
                            <span className="g_muted" style={{ fontSize: '0.82rem' }}>-</span>
                          )}
                          {isFirstOfLrn && (
                            <span
                              className="icon icon-pencil g_cursor_pointer g_muted g_m_left_10"
                              onClick={() => onUpdateMode({ ...compliance, reportType: 'scheduleVii' })}
                              style={{ verticalAlign: 'top', fontSize: '0.8rem' }}
                              title="Edit monitoring comment for this Schedule VII item"
                            />
                          )}
                        </div>
                      </td>

                      <td className="g_text_left g_muted" style={{ fontSize: '0.82rem' }}>-</td>
                      <td></td>
                    </tr>
                  );
                });

                if (isExpanded) {
                  const reportTypeOrder = {
                    dsraShortfall: 1,
                    emi: 2,
                    penalCharge: 3,
                    nachFailure: 4,
                    loanChequeBounce: 5,
                    legalCharge: 6,
                  };

                  const sortedRows = [...rows].sort((a, b) => {
                    const aOrder = reportTypeOrder[a.item.reportType] || 99;
                    const bOrder = reportTypeOrder[b.item.reportType] || 99;
                    return aOrder - bOrder;
                  });

                  const filteredRows = lrnFilter && lrnFilter.trim() !== ''
                    ? sortedRows.filter(row =>
                      row.item.lrn &&
                      row.item.lrn.toLowerCase().includes(lrnFilter.trim().toLowerCase())
                    )
                    : sortedRows;

                  if (lrnFilter && lrnFilter.trim() !== '') {
                    Object.keys(lrnDisplayTracker).forEach(key => {
                      if (key.startsWith(accountName)) {
                        delete lrnDisplayTracker[key];
                      }
                    });
                  }

                  const lrnGroupedRows = {};
                  filteredRows.forEach((row) => {
                    const lrn = row.item.lrn || 'N/A';
                    if (!lrnGroupedRows[lrn]) {
                      lrnGroupedRows[lrn] = [];
                    }
                    lrnGroupedRows[lrn].push(row);
                  });

                  Object.entries(lrnGroupedRows).forEach(([lrn, lrnRows], lrnIndex) => {
                    let shouldDisplayLrn = true;

                    const reportTypeOrderInner = {
                      dsraShortfall: 1,
                      emi: 2,
                      penalCharge: 3,
                      nachFailure: 4,
                      loanChequeBounce: 5,
                      legalCharge: 6
                    };

                    lrnRows.sort((a, b) => {
                      const aOrder = reportTypeOrderInner[a.item.reportType] || 99;
                      const bOrder = reportTypeOrderInner[b.item.reportType] || 99;
                      return aOrder - bOrder;
                    });

                    lrnRows.forEach((row, index) => {
                      const { item } = row;
                      const isNachFailure = item.reportType === "nachFailure";
                      const isLegalCharge = item.reportType === "legalCharge";
                      const isPenalCharge = item.reportType === "penalCharge";
                      const isDsraShortfall = item.reportType === "dsraShortfall";
                      const isEmi = item.reportType === "emi";
                      const isLoanChequeBounce = item.reportType === "chequeBounce";

                      loanDetailRows.push(
                        <tr key={`entry-${accountName}-${lrn}-${index}`}>
                          <td className="g_text_left"></td>
                          <td className="g_text_left"></td>
                          <td className="g_text_left">
                            {shouldDisplayLrn ? (
                              isNachFailure ? (
                                <span>{item.escAccountNumber || 'N/A'}</span>
                              ) : isDsraShortfall ? (
                                <span>N/A</span>
                              ) : (
                                <span>{item.lrn}</span>
                              )
                            ) : ''}
                          </td>

                          <td className="g_text_left">
                            <div>
                              {isNachFailure ? <Link to={`/su/accounts/${item.accountId}/nachFailure`} className="g_link">NACH Failure*</Link> :
                                isLegalCharge ? <Link to={`/su/loans/${item.loanId}/fees`} className="g_link">Legal Charge</Link> :
                                  isPenalCharge ? <Link to={`/su/loans/${item.loanId}/repayments/v2`} className="g_link">Penal Charge</Link> :
                                    isDsraShortfall ? <Link to={`/su/loans/${item.loanId}/bankAccounts`} className="g_link">DSRA Shortfall</Link> :
                                      isEmi ? <Link to={`/su/loans/${item.loanId}/bankAccounts`} className="g_link">EMI</Link> :
                                        isLoanChequeBounce ? <Link to={`/su/loans/${item.loanId}/loanCheque`} className="g_link">Cheque Bounce</Link> :
                                          item.reportType}
                            </div>
                          </td>

                          <td className="g_text_left">{item.amount || '-'}</td>
                          <td className="g_text_left">{item.amountReceived || '0'}</td>
                          <td className="g_text_left">
                            {(isEmi || isLegalCharge || isPenalCharge) && item.details ? (
                              <a
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (isEmi) {
                                    onEmiDetailsClick(item.details);
                                  } else if (isLegalCharge) {
                                    onLegalChargeDetailsClick(item.details);
                                  } else if (isPenalCharge) {
                                    onPenalChargeDetailsClick(item.details);
                                  }
                                }}
                                className="g_link"
                              >
                                {item.amountPending || '0'}
                              </a>
                            ) : (
                              `${item.amountPending || '0'}`
                            )}
                          </td>

                          <td className="g_text_left">
                            {isEmi ? ` ${item.overdueInterest || '0'}` : '-'}
                          </td>
                          <td className="g_text_left">{item.lastPaymentDate || '-'}</td>
                          <td className="g_text_left">
                            {isNachFailure ? (item.defaultDate || '-') :
                              isLegalCharge ? (item.defaultDate || '-') :
                                isEmi ? (item.defaultDate || '-') :
                                  isPenalCharge ? (item.defaultDate || '-') :
                                    isDsraShortfall ? (item.defaultDate || '-') :
                                      item.bounceDate || '-'}
                          </td>
                          <td className="g_text_left">{item.cureDate || '-'}</td>
                          <td className="g_text_left">
                            {isNachFailure ? (
                              <div>{item.reasonDescription || '-'}</div>
                            ) : isLegalCharge ? (item.defaultReason) :
                              isEmi ? (item.defaultReason || 'EMI Default') :
                                isDsraShortfall ? (
                                  <a
                                    href="#"
                                    className="g_link"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setOpenDsraClauseDialog(item.defaultReason);
                                    }}
                                  >
                                    Compliance
                                  </a>
                                ) :
                                  isPenalCharge ? (
                                    <a
                                      href="#"
                                      className="g_link"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setOpenPenalClauseDialog(item.defaultReason);
                                      }}
                                    >
                                      Compliance
                                    </a>
                                  ) : (
                                    item.bounceReason || '-'
                                  )}
                          </td>
                          <td className="g_text_left">{getStatusDisplayValue(item.closureStatus)}</td>
                          <td className="g_text_left">
                            <div className="g_flex_h g_flex_middle">
                              <span>
                                {item.monitoringAction && item.monitoringAction.trim() !== ''
                                  ? item.monitoringAction
                                  : 'Not set'}
                              </span>
                            </div>
                          </td>
                          <td className="g_text_left">
                            <div className="g_flex_h g_flex_middle">
                              <span>
                                {item.monitoringComment && item.monitoringComment.trim() !== ''
                                  ? item.monitoringComment
                                  : 'Not set'}
                              </span>
                              <span
                                className="icon icon-pencil g_cursor_pointer g_muted g_m_left_10"
                                onClick={() => onUpdateMode(item)}
                                data-object-id={item.objectId}
                                data-date={item.miActionCommentDateCreated}
                                data-remarks={item.monitoringComment}
                                style={{ verticalAlign: 'top' }}
                              ></span>
                            </div>
                          </td>
                          <td className="g_text_left">
                            {isNachFailure ? (
                              item.fileName ? (
                                <div className='g_flex_left g_flex_h'>
                                  1.&nbsp;
                                  <Link
                                    to="#"
                                    onClick={onDocDownloadClick}
                                    data-loan-id={item.loanId}
                                    data-file-name={item.fileName}
                                    className='g_link'
                                  >
                                    {item.fileName}
                                  </Link>
                                </div>
                              ) : (
                                'No files'
                              )
                            ) : isLoanChequeBounce ? (
                              item.fileUploadList && item.fileUploadList.length > 0 ? (
                                item.fileUploadList.map((fileName, index) => (
                                  <div key={index} className='g_flex_left g_flex_h'>
                                    {index + 1}.&nbsp;
                                    <Link
                                      to="#"
                                      onClick={onDocDownloadClick}
                                      data-loan-id={item.loanId}
                                      data-file-name={fileName}
                                      className='g_link'
                                    >
                                      {fileName}
                                    </Link>
                                  </div>
                                ))
                              ) : (
                                'No files'
                              )
                            ) : (
                              '-'
                            )}
                          </td>
                          <td className="g_text_left"></td>
                        </tr>
                      );
                      shouldDisplayLrn = false;
                    });
                  });
                }

                return [accountSummaryRow, ...nonFinancialRows, ...scheduleViiRows, ...loanDetailRows];
              }).flat()
            ) : (
              <tr>
                <td colSpan="17" className="g_text_center">
                  <EmptyListUI
                    context={context}
                    createEnabled={false}
                    createDisabledMessageLabel='No Monitoring Intelligence Found'
                  />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </CardUI>
  );
};

export default MonitoringIntelligenceUI;